<div class="transaction-history-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
  </div>

  <section class="container transaction-table-section">
    <article class="transaction-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">Service Requests</p>
          <h2>Service request list</h2>
        </div>
        <span class="badge-counter">{{ count || 0 }} records</span>
      </div>

      <div class="filter-section">
        <form [formGroup]="searchForm">
          <div class="filter-form-row">
            <div class="date-input-group">
              <input type="date" id="fromDate" class="form-control date-input" formControlName="fromDate" [max]="today"
                placeholder="From Date" />
              <input type="date" id="toDate" class="form-control date-input"
                [readonly]="!this.searchForm.controls['fromDate'].value" [min]="searchForm.controls['fromDate'].value"
                formControlName="toDate" placeholder="To Date" />
            </div>
            <div class="filter-buttons">
              <button type="button" class="filter-submit-btn" (click)="searchFormSubmit();currentPage =1;">
                Submit
              </button>
              <button type="button" class="filter-reset-btn" (click)="searchFormReset()">
                Reset
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <thead>
            <tr>
              <th scope="col">S.No</th>
              <th scope="col">Service Provider</th>
              <th scope="col">Image</th>
              <th scope="col">Service Id</th>
              <th scope="col">Date</th>
              <th scope="col">Category</th>
              <th scope="col">Address</th>
              <th scope="col">Payment Status</th>
              <th scope="col">Order Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                let item of orderList
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: count
                      };
                let i = index
              ">
              <td data-label="S.No">{{ 10 * (currentPage - 1) + i + 1 }}</td>
              <td data-label="Service Provider">
                {{ item?.serviceDetails[0]?.serviceId?.userId?.firstName }}
                {{ item?.serviceDetails[0]?.serviceId?.userId?.lastName }}
              </td>
              <td data-label="Image">
                <img class="imagtag" src="{{
                    item?.serviceDetails[0]?.serviceId?.userId?.profilePic
                    || 'assets/latest/placehold.png'}}" alt="" />
              </td>
              <td data-label="Service Id">{{ item?.orderId }}</td>
              <td data-label="Date">
                <span *ngIf="isDate(item?.duration)">{{ item?.duration }}</span>
                <span *ngIf="!isDate(item?.duration)">{{ item?.duration | date : "longDate" || "--" }}</span>
              </td>
              <td data-label="Category" class="category-cell">
                <span
                  [innerHTML]="getFormattedCategory(item?.serviceDetails[0]?.serviceId?.categoryId?.categoryName)"></span>
              </td>
              <td data-label="Address" class="address-cell">
                {{ getTruncatedAddress(item?.shippingFixedAddress) }}
              </td>
              <td data-label="Payment Status">
                <span class="status-chip" [ngClass]="{
                    'COMPLETED': item?.paymentStatus=='COMPLETED',
                    'completed': item?.paymentStatus=='COMPLETED',
                    'PENDING': item?.paymentStatus!='COMPLETED',
                    'pending': item?.paymentStatus!='COMPLETED'
                  }">
                  {{item?.paymentStatus}}
                </span>
              </td>
              <td data-label="Order Status">{{ item?.orderStatus }}</td>
              <td data-label="Action">
                <button class="ghost-link" (click)="viewBookingHistoryDetails(item)" aria-label="View details">
                  View
                </button>
              </td>
            </tr>
            <tr *ngIf="!isLoading && (!orderList || orderList.length === 0)">
              <td colspan="10" class="text-center p-5">
                <div class="no-data-content">
                  <img src="assets/images/notfound.png" alt="No Data Found" class="notfound-img"
                    style="width: 100px; opacity: 0.7;" />
                  <p class="mt-3 text-muted">No Data Found</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <app-table-loader *ngIf="isLoading" [isTable]="'TABLE'" [isLoading]="isLoading" [colspan]="10" [isWidth]="'55px'">
      </app-table-loader>

      <div class="transaction-table-footer" *ngIf="count > 10">
        <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
      </div>
    </article>
  </section>
</div>